import React from "react";
import ScrollTop from "./components/ScrollTop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Content from "./components/Content";

function App() {
  return (
    <>
      <Header />
      <ScrollTop />
      <Content />
      <Footer />
    </>
  );
}

export default App;
